import React from "react"
import classes from "./Shared.module.scss"

const email = (props) => {
  return (
    <a className={[classes.Email, classes[props.where]].join(' ')} href="mailto:info@medicalairrescue.com">info@medicalairrescue.com</a>
  )
}
export default email